/**
 * @author Ivan Toth.
 * gpp - autocheck tlogs table
 */
var DetailValidDecController = (function () {
    function DetailValidDecController(topic, socket, $stateParams, env) {
        this.topic = topic;
        this.socket = socket;
        this.$stateParams = $stateParams;
        this.env = env;
        this.comp = 'valid_dec';
        this.diffArray = [];
        this.id = $stateParams.id;
    }
    ;
    DetailValidDecController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailValidDecController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            // Check if we can update the values if yes continue to update temp
            this.edit.editMode = this.topic.setTopicFromTempPart(this.comp);
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailValidDecController.prototype.runAutoCheck = function () {
        console.log('I AM CLICKING RUN auto-check');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'runAutoCheck',
                script: '/detail/validation/validation',
                opp: this.id,
                token: this.env.user.token
            }
        });
    };
    DetailValidDecController.$inject = ['topic', 'socket', '$stateParams', 'env'];
    return DetailValidDecController;
}());
var DetailValidDecComponent = (function () {
    function DetailValidDecComponent() {
        this.templateUrl = 'detail-validation-decision.html';
        this.controllerAs = 'vm';
        this.controller = DetailValidDecController;
    }
    return DetailValidDecComponent;
}());
angular
    .module('application')
    .component('detailValidDec', new DetailValidDecComponent());

//# sourceMappingURL=detail.validation.gpp-ac.component.js.map
